import Rest from './rest';

const RESOURCE = "client";

export default {

    list: function (params) {
        return Rest.get(RESOURCE, {params});
    },

    downloadExcel: function (params) {
        return Rest.downloadExcel(`${RESOURCE}/excel`, null, {params});
    },

    downloadDiscTemplate:function(){
        return Rest.downloadExcel(`${RESOURCE}/batch/disc/template`);
    }

};



// WEBPACK FOOTER //
// ./src/services/ClientService.js